<template lang="pug">
  div
    table
      tr(v-if="data.properties.wmo")
        td WMO
        td {{ data.properties.wmo }}
      tr(v-if="data.properties.imei")
        td IMEI
        td {{ data.properties.imei }}
      tr(v-if="data.properties.id")
        td ID
        td {{ data.properties.id }}  
      tr
        td MODEL
        td {{ data.properties.model }}
      tr(v-if="data.properties.nationality")
        td NATIONALITY
        td {{ data.properties.nationality}}
      tr(v-if="data.properties.type")
        td DAY
        td {{ data.properties.time | day }}
      tr(v-if="data.geometry.type === 'Point'")
        td TIME
        td {{ data.properties.time | time }}
      tr(v-if="data.geometry.type === 'Point'")
        td LATITUDE
        td {{ data.geometry.coordinates[1].toFixed(2) }}
      tr(v-if="data.geometry.type === 'Point'")
        td LONGITUDE
        td {{ data.geometry.coordinates[0].toFixed(2) }}
    div(v-if="data.geometry.type !== 'LineString'" class="actions is-hidden-tablet")
      button(class="action-track" type="button" @click="toggleTrack()") {{ trackLabel }}
    div(v-if="data.geometry.type === 'LineString'" class="actions")
      button(class="action-remove" type="button" @click="removeTrj(data.properties.id)") Hide Track
</template>

<script>
import moment from 'moment'
export default {
  name: 'PopupContent',
  props: {
    data: {
      type: Object,
      default: () => ({
        marker: ''
      })
    }
  },
  data () {
    return {
      trackLabel: 'View Track',
      trackStatus: true
    }
  },
  methods: {
    removeTrj (id) {
      this.data.properties.delete = true
      this.$store.commit('UNSET_TRAJECTORY', id)
    },
    toggleTrack () {
      const type = this.data.properties.type
      const id = this.data.properties.id
      const from = this.$store.state.mapFilters.date_from
      const to = this.$store.state.mapFilters.date_to
      if (this.trackStatus) {
        this.$store.dispatch('LOAD_TRAJECTORY', `type=${type}&id=${id}&date_from=${from}&date_to=${to}`)
        this.trackStatus = !this.trackStatus
        this.trackLabel = 'Hide Track'
      } else {
        this.removeTrj(id)
        this.trackStatus = !this.trackStatus
        this.trackLabel = 'View Track'
      }
    }
  },
  filters: {
    day: function (date) {
      return moment(date).format('DD/MM/YYYY')
    },
    time: function (date) {
      return moment(date).format('H:mm')
    }
  }
}
</script>

<style lang="scss" scoped>
  td {
    border: 1px solid #c2c2c2;
    padding: .4em;
  }
  td:first-child {
    font-weight: bold;
  }
  tr:nth-child(odd)		{ background-color:#eee; }
  tr:nth-child(even)		{ background-color:#fff; }

  .actions {
    text-align: center;
    padding: .7em;
    button {
      cursor: pointer;
      border: 1px solid silver;
      &:hover {
        background-color: #f2f2f2;
      }
    }
  }


</style>



// WEBPACK FOOTER //
// src/components/PopupContent.vue